<template>
	<div class="k-dialog">
		<v-dialog v-model="dialog" :width="null != width ? width : isSelectFooterBtn ? 900 : 500">
			<template v-slot:activator="{ props }">
				<v-btn v-if="isOpenDialogAction && isActivatorBtn" :color="defaultActivatorColorBtn" v-bind="props" :class="{'dialog__select-footer-btn': isSelectFooterBtn}">
					{{ defaultActivatorTitleBtn }}
				</v-btn>
			</template>

			<v-card :class="{'card-font-large': isLargeFontSizeTitle}">
				<v-card-title class="text-h5 lighten-2 dialog__primary header-title-wrapper" v-if="contentHeader">
					<div>{{ dynamicContentTitle }} {{ null != dynamicContentTitle ? null : defaultContentTitle }} <span>{{ contentSecondTitle }}</span></div>
				</v-card-title>

				<v-card-text>
                    <div v-if="closeHeaderBtn" @click="dialog = false" class="close-header-btn">
                        <KIcon icon="close" width="25" height="25" />
                    </div>
					<slot></slot>
				</v-card-text>

				<v-divider v-if="closeBtn"></v-divider>

				<v-card-actions v-if="closeBtn">
					<v-spacer></v-spacer>
					<v-btn :color="defaultCloseColorDialogBtn" @click="dialog = false">
						{{ defaultCloseTitleBtn }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script setup lang="ts">
import { defineEmits, defineProps, ref, withDefaults, watch } from 'vue';
import variables from '@/assets/scss/modules/variables.module.scss';
import KIcon from '@/components/atoms/KIcon.vue';

const dialog = ref(false);
const emit = defineEmits(['closeDialog']);

interface IOwnProps {
	isOpenDialogAction: boolean
	isCloseDialogAction: boolean
	contentTitle?: string
	dynamicContentTitle?: string
	isActivatorBtn?: boolean
	activatorColorBtn?: string
	closeColorDialogBtn?: string
	activatorTitleBtn?: string
	contentHeader?: boolean
	contentSecondTitle?: string
	closeTitleBtn?: string
	closeBtn?: boolean
	isSelectFooterBtn?: boolean
	closeHeaderBtn?: boolean
	isLargeFontSizeTitle?: boolean
	width?: number | string
}
interface IProps extends IOwnProps {
}

const { primary400, secondary400 } = variables;

const props = withDefaults(defineProps<IProps>(), {
	contentHeader: false,
	closeBtn: false,
	isSelectFooterBtn: false,
	isOpenDialogAction: false,
	isCloseDialogAction: false,
	closeHeaderBtn: false,
	isLargeFontSizeTitle: false,
	isActivatorBtn: false,
});

const defaultActivatorColorBtn = props.activatorColorBtn || primary400;
const defaultCloseColorDialogBtn = props.closeColorDialogBtn || secondary400;
const defaultActivatorTitleBtn = props.activatorTitleBtn || `${t('common.click')}`;
const defaultContentTitle = props.contentTitle || `${t('common.title')}`;
const defaultCloseTitleBtn = props.closeTitleBtn || `${t('common.cancel')}`;

const openDialogAction = () => {
	dialog.value = true;
}

watch(props, (val) => {
	if (val.isOpenDialogAction) {
		openDialogAction();
	}
	if (val.isCloseDialogAction) {
		closeDialogAction();
	}
});

const closeDialogAction = () => {
	dialog.value = false;
}

watch((dialog), (val) => {
	if (!val) {
		emit('closeDialog');
	}
});

</script>

<style scoped lang="scss">
.dialog {
	&__primary {
		background-color: $primary-400;
		color: $white;
		margin-bottom: 10px;
	}

	&__select-footer-btn {
		margin-left: 15px;
	}
}

.header-title-wrapper {
	display: flex;
	align-items: baseline;
	justify-content: space-between;

	span {
		font-weight: 700;
		margin-left: 5px;
	}
}

.card-font-large {
	div:nth-child(1) {
		font-size: 27px;
		display: flex;
		align-items: center;
		gap: 5px;
		justify-content: space-between;
	}
	div:nth-child(2) {
		font-size: 18px;
		padding: 9px 8px 9px 15px;
	}
}

.close-header-btn {
    position: absolute;
    top: 15px;
    right: 15px;
	margin-left: auto;
	cursor: pointer;
	transition: opacity 0.3s;

    svg {
        fill: $black;
    }

	&:hover {
		opacity: 0.5;
	}
}
</style>
